import { Col, Layout, Tabs } from "antd";
import TabPane from "antd/es/tabs/TabPane";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import ActiveCollectionIcon from "../../../assets/icons/active-collection.svg";
import ActiveGridIcon from "../../../assets/icons/active-grid.svg";
import CollectionIcon from "../../../assets/icons/collection.svg";
import GridIcon from "../../../assets/icons/grid.svg";
import ApplicationNameChangeHeaderBar from "../../../components/ApplicationNameChange/ApplicationNameChangeHeaderBar";
import CollectionCancelEditModeButtonComponent from "../../../components/Collections/CollectionCancelEditModeButtonComponent";
import CollectionGridComponent from "../../../components/Collections/CollectionGridComponent";
import FooterComponent from "../../../components/FooterComponent";
import { FOOTER_IDS } from "../../../helpers/constant";
import useProfileCustomPageInfos from "../../../hooks/global/useProfileCustomPageInfos";
import useDecodedToken from "../../../hooks/userHooks/useDecodedToken";
import useFetchUserInfos from "../../../hooks/userHooks/useFetchUserInfos";
import useFetchUserSettings from "../../../hooks/userHooks/useFetchUserSettings";
import { updateFile } from "../../../redux/feeds/feedsSlice";
import { AppDispatch } from "../../../redux/store";
import { socket } from "../../../socket";
import FeedGridComponent from "./FeedGridComponent";
import "./index.less";
import ProfileEvent from "./ProfileEvent";
import UserInfoComponent from "./UserInfoComponent";

const CurrentUserProfilePage: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();

  const { currentUser: user } = useFetchUserInfos();
  const { currentUserSettings } = useFetchUserSettings();
  const [activeTab, setActiveTab] = useState<string>(localStorage.getItem("activeProfileTab") || currentUserSettings?.defaultPage || "feeds");
  const { connectedUsername } = useDecodedToken();
  useProfileCustomPageInfos({ username: connectedUsername, t });
  const [collectionEditMode, setCollectionEditMode] = useState<boolean>(false);

  useEffect(() => {
    if (currentUserSettings) {
      setActiveTab(localStorage.getItem("activeProfileTab") || currentUserSettings.defaultPage || "feeds");
    }
  }, [currentUserSettings]);

  useEffect(() => {
    function handleFileUpdated(data: { fileId: string; absolutePath: string; thumbnails: any; status: string }) {
      dispatch(updateFile(data));
    }

    socket.on("file-updated", handleFileUpdated);

    return () => {
      socket.off("file-updated", handleFileUpdated);
    };
  }, [dispatch]);

  const handleTabChange = (key: string) => {
    localStorage.setItem("activeProfileTab", key);
    setActiveTab(key);
  };

  //TODO check if the default page work
  // useEffect(() => {
  //   const activeTabFromLocalStorage = localStorage.getItem("activeProfileTab");
  //   if (activeTabFromLocalStorage) {
  //     setActiveTab(activeTabFromLocalStorage);
  //   } else {
  //     setActiveTab(user?.defaultPage || "collection");
  //   }
  // }, [user]);

  /**
   * TODO : need to add this destroyInactiveTabPane={true} to the Tabs component to avoid the load for the inactive tab
   */
  return (
    <Layout className="gradient-background-profile no-scroll-horizontal">
      <ApplicationNameChangeHeaderBar />
      <Layout.Content className="content fanProfileContentWrapper background-transparent">
        {user && <UserInfoComponent user={user.infos} userSettings={currentUserSettings} />}
        {user && <ProfileEvent creatorId={user?.id!} username={user.infos.username!} isMyProfile={true} userSettings={currentUserSettings} />}
        <Col className="feeds-container">
          <Tabs activeKey={activeTab} onChange={handleTabChange}>
            <TabPane tab={<img src={activeTab === "feeds" ? ActiveGridIcon : GridIcon} width={20} alt="publications icon" />} key="feeds">
              <FeedGridComponent isMyProfile={true} creatorId={user?.id!} subscribed={true} />
            </TabPane>

            <TabPane
              tab={<img src={activeTab === "collection" ? ActiveCollectionIcon : CollectionIcon} width={20} alt="collections icon" />}
              key="collection"
            >
              <CollectionGridComponent
                isMyProfile={true}
                creatorId={user?.id}
                username={connectedUsername}
                goToPublicationTab={() => handleTabChange("feeds")}
                setCollectionEditMode={(value) => {
                  setCollectionEditMode(value);
                }}
              />
            </TabPane>
          </Tabs>
        </Col>
      </Layout.Content>
      {collectionEditMode ? <CollectionCancelEditModeButtonComponent /> : <FooterComponent page={FOOTER_IDS.PROFILE} />}
    </Layout>
  );
};

export default CurrentUserProfilePage;
